<template>
  <div class="login-box">
    <!-- return返回 -->
    <div class="return-box" @click="returnButton">
      <el-icon><ArrowLeft /></el-icon>
      返回
    </div>
    <div class="a-box">
      <p class="title-box">重置密码</p>

      <!-- 目录 -->
      <div class="login-list">
        <!-- 因手机号验证有bug 所以以下需要暂时注释 -->
        <el-tabs
          type="border-card"
          v-model="mydata.activeName"
          @tab-change="tabChange"
        >
          <el-tab-pane label="手机号找回" name="first">
            <phoneNumberRetrieval
              v-model:myphonenum="mydata.form.phonenum"
              v-model:myphonecode="mydata.form.phonecode"
            ></phoneNumberRetrieval>
          </el-tab-pane>

          <el-tab-pane label="邮箱找回" name="second">
            <emailRetrieval
              v-model:myemail="mydata.form2.email"
              v-model:myemailcode="mydata.form2.emailcode"
            ></emailRetrieval>
          </el-tab-pane>
        </el-tabs>

        <!-- 因手机号验证有bug 所以以下邮箱验证只是暂时使用 -->
        <!-- <el-tag
          type="primary"
          style="height: 32px; margin-bottom: 25px; font-size: 15px"
          >邮箱找回</el-tag
        >
        <emailRetrieval
          v-model:myemail="mydata.form2.email"
          v-model:myemailcode="mydata.form2.emailcode"
        ></emailRetrieval> -->
      </div>

      <!-- 重置密码按钮 -->
      <el-button type="primary" class="submit-button" @click="newPasswordButton"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";

import phoneNumberRetrieval from "@/views/login/retrievePasswordLogin/phoneNumberRetrieval/index.vue";
import emailRetrieval from "@/views/login/retrievePasswordLogin/emailRetrieval/index.vue";

const router = useRouter();

var mydata = reactive({
  btnLoading: false,
  zhanghao: "",
  mima: "",
  form: {
    phonenum: "",
    phonecode: "",
  },
  form2: {
    email: "",
    emailcode: "",
  },
  activeName: "first",
});

function tabChange(tab) {
  // console.log("这是tabs目录", tab);
  // 重置数据
  mydata.form = {
    phonenum: "",
    phonecode: "",
  };
  mydata.form2 = {
    email: "",
    emailcode: "",
  };
}

//按钮的事件函数
function submit() {
  // 跳转页面
  router.push({
    // path: "/layout/list/personalCenter",
    path: "/layout/list/personalCenter/personalInfor",
  });

  // console.log(mydata.zhanghao, mydata.mima);
  // mydata.btnLoading = true;
  // axios({
  //   method: "post",
  //   url: "/house/login/login",
  //   data: {
  //     //请求参数（get请求的时候必须用params，post请求的时候必须用data）
  //     account: mydata.zhanghao,
  //     password: mydata.mima,
  //     // sourceText: mydata.zhanghao + mydata.mima, //sourceText就是这次项目的后端跟你说的必须用什么属性名，否则后端就拿不到了；属性值是我要传给后端的内容
  //   },
  // }).then((res) => {
  //   mydata.btnLoading = false;
  //   if (res.data.code === 1) {
  //     ElMessage({
  //       message: res.msg,
  //       type: "success",
  //     });

  //     // 存储后端返回的token值
  //     localStorage.setItem("token", res.data.data.token);
  //     localStorage.setItem("adminName", mydata.zhanghao);

  //     // 跳转页面
  //     router.push({
  //       path: "/layout/list/personalCenter/personalInfor/index.vue",
  //     });

  //     mydata.zhanghao = "";
  //     mydata.mima = "";
  //   }
  // });
}

// 是否为空白字符串
function isWhiteStr(str) {
  let reg = /^\s*$/;
  return reg.test(str);
}

//下一步（新密码）的点击事件
function newPasswordButton() {
  // 手机号找回 ----------------------因手机号验证有bug 所以if条件只是暂时注释，等手机号验证解决后 方可放开注释
  if (mydata.activeName === "first") {
    // 如果手机号为空
    if (isWhiteStr(mydata.form.phonenum)) {
      // 提示弹窗
      ElMessage({
        message: "手机号不得为空",
        type: "warning",
      });
      // 终止执行
      return;
    }
    // 如果验证码为空
    if (isWhiteStr(mydata.form.phonecode)) {
      // 提示弹窗
      ElMessage({
        message: "验证码不得为空",
        type: "warning",
      });
      // 终止执行
      return;
    }
    //////////////////////////
    // 其实这里还得调用一个接口，表示手机号或邮箱以及验证码正确，这样才可以跳转到重置密码的输入新密码的页面。
    //////////////////////////
    localStorage.setItem("forgetPasswordType", "phone");
    localStorage.setItem(
      "forgetPasswordObj",
      JSON.stringify({
        account: mydata.form.phonenum,
        code: mydata.form.phonecode,
      })
    );
    // 页面跳转
    router.push({
      path: "/login/newPassword",
    });
  }

  // 邮箱找回 --------------------------因手机号验证有bug 所以if条件只是暂时注释，等手机号验证解决后 方可放开if (mydata.activeName === "second")注释
  if (mydata.activeName === "second") {
    // 如果邮箱为空
    if (isWhiteStr(mydata.form2.email)) {
      // 提示弹窗
      ElMessage({
        message: "邮箱不得为空",
        type: "warning",
      });
      // 终止执行
      return;
    }
    // 如果验证码为空
    if (isWhiteStr(mydata.form2.emailcode)) {
      // 提示弹窗
      ElMessage({
        message: "验证码不得为空",
        type: "warning",
      });
      // 终止执行
      return;
    }

    //////////////////////////
    // 其实这里还得调用一个接口，表示手机号或邮箱以及验证码正确，这样才可以跳转到重置密码的输入新密码的页面。
    //////////////////////////
    localStorage.setItem("forgetPasswordType", "email");
    localStorage.setItem(
      "forgetPasswordObj",
      JSON.stringify({
        account: mydata.form2.email,
        code: mydata.form2.emailcode,
      })
    );
    // 页面跳转
    router.push({
      path: "/login/newPassword",
    });
  }
}

//返回上一页 点击事件
function returnButton() {
  router.push({
    path: "/login/nowLogin",
  });
}
</script>

<style scoped lang="scss">
//登录盒子
.login-box {
  // width: 450px;
  // height: 467px;
  background-color: #ffffff;
  // border: 1px solid rgb(255, 238, 0);
  border-radius: 8px;
  // padding: 0px 46px !important;

  ////////返回
  .return-box {
    margin: 0 auto;
    // border: 1px solid blue;
    margin: 20px 0px 14px 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
    :deep(.el-icon) {
      font-size: 16px;
      font-weight: 700;
      margin-right: 5px;
    }
    p:hover {
      color: #009de0;
    }
  }
  ////////一个盒子
  .a-box {
    margin: 0px 16px;
    //////// 重置密码
    .title-box {
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      // border: 1px solid red;
      margin-bottom: 14px;
    }
  }

  //目录
  .login-list {
    //  width: 296px !important;
    //  margin:0 auto;
    // margin-top: 40px;
    // border: 1px solid red;

    ////整体 tabs
    :deep(.el-tabs.el-tabs--top.el-tabs--border-card) {
      border: none;
    }

    /////整体宽度字的宽度
    :deep(.el-tabs__nav.is-top) {
      // border: 1px solid blue;
      width: 165px !important;
      height: 44px;
      display: flex;
      justify-content: space-between !important;
      align-items: center;
      background-color: #f8faf5;
      border-radius: 8px;
      padding: 4px;
      // border:1px solid rgb(38, 0, 255);
    }

    ////整个目录长度
    :deep(.el-tabs__nav-scroll) {
      // border:1px solid red;
      border: none;
      height: 44px;
      background-color: #ffffff;
    }

    //////每个字体
    :deep(.el-tabs__item.is-top) {
      text-align: center;
      // padding: 5px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      // border:1px solid red;
      margin-right: 5px;
      width: 78px;
    }
    //第一个字体
    :deep(.el-tabs__item.is-top:nth-of-type(1)) {
      // padding:10px;
      width: 78px;
      // border:1px solid blue;
      // margin-left:5px;
    }
    //第二个字体
    :deep(.el-tabs__item.is-top:nth-of-type(2)) {
      // padding:10px;
      width: 67px;
      // border:1px solid blue;
    }

    /////目录字体被激活时
    :deep(.el-tabs__item.is-top.is-active) {
      background-color: #ffffff;
      border: none;
      border-radius: 8px;
      // padding:10px;
    }
    /////第一个字体被激活时
    :deep(.el-tabs__item:nth-of-type(1).is-top.is-active) {
      width: 78px;
      // border:1px solid rgb(60, 255, 0);
    }
    /////第二个字体被激活时
    :deep(.el-tabs__item:nth-of-type(2).is-top.is-active) {
      width: 67px;
      padding-left: 0px;
      padding-right: 0px;
      // border:1px solid red;
    }

    //目录的内容部分
    :deep(.el-tabs__content) {
      padding-left: 0px;
      padding-right: 0px;
    }

    // //左边箭头
    // :deep(.el-tabs__nav-prev) {
    //   display: none;
    // }
    // //目录右边箭头
    // :deep(.el-tabs__nav-next) {
    //   display: none;
    // }
  }
}

/////////////////两个按钮
:deep(.el-button) {
  width: 311px;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
}

//两个按钮一起用会有margin-left:12px;
:deep(.el-button + .el-button) {
  margin-left: 0px;
}

:deep(.el-button.el-button--primary) {
}

// 重置密码按钮
:deep(.el-button.el-button--primary.submit-button) {
  margin-top: 10px;
}

:deep(.el-tabs__nav-scroll .el-tabs__item.is-top) {
  border: none !important;
}
</style>
